import { useMemo } from 'react';
import { type SummarizePluginResult, type SummarizeCampaignResponse } from '../../types';

export function useNormalizedPerfMetrics({ isReportingInsights15Enabled, summarizePluginResult }: { isReportingInsights15Enabled: boolean, summarizePluginResult?: SummarizePluginResult }) {
  const pluginResult = useMemo<SummarizeCampaignResponse['perfMetricsWithComparisonData']>(() => {
    const result = summarizePluginResult?.Result;
    if (!result) {
      return undefined;
    }

    if (isReportingInsights15Enabled && result.perfMetricsWithComparisonData) {
      return result.perfMetricsWithComparisonData;
    }

    // pilot not enabled yet, normalize the old result to the newer format, with no comparison data
    return {
      impressions: { currentValue: result.impressionCount },
      clicks: { currentValue: result.clickCount },
      ctr: { currentValue: result.ctr },
      spend: { currentValue: result.spend },
      conversions: { currentValue: result.conversionCount },
      cpa: { currentValue: result.cpa },
      roas: { currentValue: result.roas },
      averageCPC: { currentValue: result.averageCPC },
      averageCPM: { currentValue: result.averageCPM },
      impressionShare: { currentValue: result.impressionShare },
      uniqueReach: { currentValue: result.uniqueReach },
      averageCPV: { currentValue: result.averageCPV },
      videoViews: { currentValue: result.videoViews },
      videoCompletionRate: { currentValue: result.videoCompletionRate },
      videoViewsAt25Percent: { currentValue: result.videoViewsAt25Percent },
      videoViewsAt50Percent: { currentValue: result.videoViewsAt50Percent },
      videoViewsAt75Percent: { currentValue: result.videoViewsAt75Percent },
      installs: { currentValue: result.installs },
      downloads: { currentValue: result.downloads },
      averageCPI: { currentValue: result.averageCPI },
    };
  }, [isReportingInsights15Enabled, summarizePluginResult]);

  return pluginResult;
}
